import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { UrgencyBar } from './UrgencyBar';
import { HeroSection } from './HeroSection';
import { HeroSupportImage } from './HeroSupportImage';
import { EmotionalOpening } from './EmotionalOpening';
import { BeforeAfterOutdoor } from './BeforeAfterOutdoor';
import { BeforeAfterAction } from './BeforeAfterAction';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { PhoneOnlyProof } from './PhoneOnlyProof';
import { WhyDifferent } from './WhyDifferent';
import { SystemImage } from './SystemImage';
import { WhatsIncluded } from './WhatsIncluded';
import { ResultPortrait } from './ResultPortrait';
import { ResultPersonality } from './ResultPersonality';
import { ResultSeasonal } from './ResultSeasonal';
import { BonusesSection } from './BonusesSection';
import { OfferStack } from './OfferStack';
import { GuaranteeSection } from './GuaranteeSection';
import { EmotionalClosing } from './EmotionalClosing';
import { TestimonialsSection } from './TestimonialsSection';
import { ResultsCollage } from './ResultsCollage';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { FooterSection } from './FooterSection';
// Lazy-load PurchaseNotification to defer framer-motion bundle (~47 KiB savings)
const PurchaseNotification = lazy(() => import('./PurchaseNotification').then(m => ({
  default: m.PurchaseNotification
})));
export function SalesPage() {
  useEffect(() => {
    // Preload LCP hero image for faster discovery
    const preloadHero = document.createElement('link');
    preloadHero.rel = 'preload';
    preloadHero.as = 'image';
    preloadHero.href = 'https://cdn.magicpatterns.com/uploads/3PT8RfiEcKK1SiRHns82tF/ChatGPT_Image_Mar_20,_2026,_10_20_45_AM.png';
    document.head.appendChild(preloadHero);
    // Defer Meta Pixel — load after page is idle to avoid blocking
    const initPixel = () => {
      if (!(window as any).fbq) {
        const n: any = (window as any).fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!(window as any)._fbq) (window as any)._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = document.createElement('script');
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        t.onload = () => {
          ;
          (window as any).fbq('init', '1538074310626033');
          (window as any).fbq('track', 'PageView');
        };
        document.head.appendChild(t);
        const noscriptImg = document.createElement('img');
        noscriptImg.height = 1;
        noscriptImg.width = 1;
        noscriptImg.style.display = 'none';
        noscriptImg.src = 'https://www.facebook.com/tr?id=1538074310626033&ev=PageView&noscript=1';
        document.body.appendChild(noscriptImg);
      }
      if ((window as any).fbq && (window as any).fbq.loaded) {
        ;
        (window as any).fbq('init', '1538074310626033');
        (window as any).fbq('track', 'PageView');
      }
    };
    // Use requestIdleCallback to defer pixel loading, fallback to setTimeout
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(initPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(initPixel, 2000);
    }
  }, []);
  return <div className="min-h-screen w-full bg-warm-light selection:bg-orange selection:text-white" data-id="element-247">
      {/* Section 1 — Top Bar */}
      <UrgencyBar data-id="element-248" />

      {/* Section 2 — Hero */}
      <HeroSection data-id="element-249" />

      {/* Section 3 — Hero Support Image */}
      <HeroSupportImage data-id="element-250" />

      {/* Section 4 — Emotional Problem */}
      <EmotionalOpening data-id="element-251" />

      {/* Section 6 — Before / After Outdoor */}
      <BeforeAfterOutdoor data-id="element-252" />

      {/* Section 7 — Before / After Action */}
      <BeforeAfterAction data-id="element-253" />

      {/* Section 8 — Problem List */}
      <ProblemSection data-id="element-254" />

      {/* Section 9 — Solution */}
      <SolutionSection data-id="element-255" />

      {/* Section 10 — Phone-Only Proof */}
      <PhoneOnlyProof data-id="element-256" />

      {/* Section 11 — Why This Is Different */}
      <WhyDifferent data-id="element-257" />

      {/* Section 12 — System Image */}
      <SystemImage data-id="element-258" />

      {/* Section 13 — What's Inside */}
      <WhatsIncluded data-id="element-259" />

      {/* Section 14 — Result: Portrait */}
      <ResultPortrait data-id="element-260" />

      {/* Section 15 — Result: Personality */}
      <ResultPersonality data-id="element-261" />

      {/* Section 16 — Result: Seasonal */}
      <ResultSeasonal data-id="element-262" />

      {/* Section 17–20 — Bonuses */}
      <BonusesSection data-id="element-263" />

      {/* Section 21 — Offer */}
      <OfferStack data-id="element-264" />

      {/* Section 22 — Guarantee */}
      <GuaranteeSection data-id="element-265" />

      {/* Section 23 — Emotional Closing */}
      <EmotionalClosing data-id="element-266" />

      {/* Section 24 — Testimonials */}
      <TestimonialsSection data-id="element-267" />

      {/* Section 25 — Results Collage */}
      <ResultsCollage data-id="element-268" />

      {/* Section 26 — FAQ */}
      <FAQSection data-id="element-269" />

      {/* Section 27 — Final Close */}
      <FinalCTA data-id="element-270" />

      {/* Footer */}
      <FooterSection data-id="element-271" />

      {/* Lazy-loaded notification popup (defers framer-motion) */}
      <Suspense fallback={null} data-id="element-272">
        <PurchaseNotification data-id="element-273" />
      </Suspense>
    </div>;
}